import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import CharField from 'components/forms/CharField/CharField'

export default function PostalCodeField ({ name, disabled, required }) {
  return (
    <CharField
      name={name}
      required={required}
      disabled={disabled}
      labelComponent={(
        <FormattedMessage
          id='premium.checkout.card_postal_code'
          defaultMessage='Postal code'
        />
      )}
      errorComponent={(
        <FormattedMessage
          id='premium.checkout.card_postal_code_error'
          defaultMessage='Postal code required'
        />
      )}
    />
  )
}

PostalCodeField.propTypes = {
  name: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
}



// WEBPACK FOOTER //
// ./src/components/premium/CCForm/PostalCodeField.jsx